module.exports = __webpack_public_path__ + "static/media/new-app-banner.8364ee56.png";